/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentStatsResponse
 */
export interface TournamentStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof TournamentStatsResponse
     */
    totalEntryFees: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentStatsResponse
     */
    totalPrizePools: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentStatsResponse
     */
    platformTake: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentStatsResponse
     */
    activeCount: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentStatsResponse
     */
    registrationCount: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TournamentStatsResponse
     */
    statusCounts: { [key: string]: number; };
}

/**
 * Check if a given object implements the TournamentStatsResponse interface.
 */
export function instanceOfTournamentStatsResponse(value: object): value is TournamentStatsResponse {
    if (!('totalEntryFees' in value) || value['totalEntryFees'] === undefined) return false;
    if (!('totalPrizePools' in value) || value['totalPrizePools'] === undefined) return false;
    if (!('platformTake' in value) || value['platformTake'] === undefined) return false;
    if (!('activeCount' in value) || value['activeCount'] === undefined) return false;
    if (!('registrationCount' in value) || value['registrationCount'] === undefined) return false;
    if (!('statusCounts' in value) || value['statusCounts'] === undefined) return false;
    return true;
}

export function TournamentStatsResponseFromJSON(json: any): TournamentStatsResponse {
    return TournamentStatsResponseFromJSONTyped(json, false);
}

export function TournamentStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalEntryFees': json['totalEntryFees'],
        'totalPrizePools': json['totalPrizePools'],
        'platformTake': json['platformTake'],
        'activeCount': json['activeCount'],
        'registrationCount': json['registrationCount'],
        'statusCounts': json['statusCounts'],
    };
}

export function TournamentStatsResponseToJSON(json: any): TournamentStatsResponse {
    return TournamentStatsResponseToJSONTyped(json, false);
}

export function TournamentStatsResponseToJSONTyped(value?: TournamentStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalEntryFees': value['totalEntryFees'],
        'totalPrizePools': value['totalPrizePools'],
        'platformTake': value['platformTake'],
        'activeCount': value['activeCount'],
        'registrationCount': value['registrationCount'],
        'statusCounts': value['statusCounts'],
    };
}

